import { type Auth0ContextInterface } from '@equipmentshare/auth0-react'

import { getAuthOrRedirect } from '../utils/auth'
import { type Auth, type Asset } from '../../types'
import { getApiUrl, getHeaders, getAndValidateResponseData } from '../utils'

export const fetchAsset = async( auth0: Auth0ContextInterface, assetId: string ): Promise<Asset> => {
	const { jwt }: Auth = await getAuthOrRedirect( auth0 )

	const uri = `${getApiUrl()}/assets/${assetId}`
	const { data } = await getAndValidateResponseData( await fetch( uri, {
		headers: {
			...getHeaders( jwt ),
			'x-fields': '{ custom_name }',
		},
		method: 'GET',
	} ) )

	return data as Asset
}
